module.exports = __webpack_public_path__ + "media/images/countrysquared/sm-c3a7d7fd5af066b07ff1ba856584db8b.svg";